export class KeyPressListener {
  constructor(key, callback) {
    let keySafe = true;
    this.keydownFunction = function (event) {
      //Do not fire these commands if we are typing in an <input />
      if (event.target.nodeName === "INPUT") {
        return;
      }
      if (event.code === key) {
        if (keySafe) {
          keySafe = false;
          callback();
        }
      }
    };
    this.keyupFunction = function (event) {
      if (event.code === key) {
        keySafe = true;
      }
    };
    document.addEventListener("keydown", this.keydownFunction);
    document.addEventListener("keyup", this.keyupFunction);
  }

  unbind() {
    document.removeEventListener("keydown", this.keydownFunction);
    document.removeEventListener("keyup", this.keyupFunction);
  }
}
